import { NaniumObject, Type } from 'nanium/objects';
import { AnabinCountry } from '../../anabin/countries/country.contractpart';

export class Country extends NaniumObject<Country> {
	@Type(String) id: string;
	@Type(String) nameDE?: string;
	@Type(String) nameEN?: string;
	@Type(Number) hisInOneId?: number;
	@Type(String) hisInOneIUniqueName?: string;
	@Type(Boolean) euMember?: boolean;
	@Type(Boolean) ewrMember?: boolean;
	@Type(Boolean) oecd?: boolean;
	@Type(String) continent?: string;
	@Type(String) iso2?: string;
	@Type(String) iso3?: string;
	@Type(AnabinCountry) anabin?: AnabinCountry;
}
